export const AWS_INSTANCE_TYPES = [
  "r6in.metal",
  "m8a.8xlarge",
  "c8g.48xlarge",
  "m8gb.medium",
  "m6a.2xlarge",
  "m5d.xlarge",
  "c6a.16xlarge",
  "g6e.8xlarge",
  "m6idn.large",
  "r7a.xlarge",
  "m7gd.large",
  "c3.8xlarge",
  "r6g.medium",
  "i4i.16xlarge",
  "r7a.2xlarge",
  "m6gd.4xlarge",
  "m8azn.3xlarge",
  "r6gd.medium",
  "c8gn.4xlarge",
  "r8gb.8xlarge",
  "trn1.32xlarge",
  "r6a.xlarge",
  "r5dn.8xlarge",
  "r6in.24xlarge",
  "c6a.24xlarge",
  "r6gd.2xlarge",
  "m8id.16xlarge",
  "x8g.2xlarge",
  "m5a.16xlarge",
  "c8gd.48xlarge",
  "c8ib.32xlarge",
  "m5n.16xlarge",
  "m8idb.16xlarge",
  "r8g.4xlarge",
  "mac2-m2.metal",
  "c7gn.16xlarge",
  "r7iz.16xlarge",
  "m8gd.metal-48xl",
  "r8i.48xlarge",
  "t4g.nano",
  "m7i-flex.12xlarge",
  "r8ib.xlarge",
  "m2.4xlarge",
  "f2.6xlarge",
  "m8gb.xlarge",
  "r8a.large",
  "c6gn.16xlarge",
  "m6gd.12xlarge",
  "c8a.2xlarge",
  "x2gd.metal",
  "m7i.metal-24xl",
  "x2iedn.2xlarge",
  "m5a.2xlarge",
  "m8ib.16xlarge",
  "t2.2xlarge",
  "c3.large",
  "c7gd.medium",
  "r6a.metal",
  "i7ie.24xlarge",
  "x1e.8xlarge",
  "c7a.xlarge",
  "c8ine.xlarge",
  "u7i-6tb.112xlarge",
  "d3en.2xlarge",
  "r8g.12xlarge",
  "m8gn.large",
  "r6i.xlarge",
  "m8in.16xlarge",
  "r8id.16xlarge",
  "r8in.xlarge",
  "g6.24xlarge",
  "r6g.16xlarge",
  "c6i.32xlarge",
  "m5zn.2xlarge",
  "r8a.2xlarge",
  "c7i.2xlarge",
  "x2iezn.4xlarge",
  "r6id.16xlarge",
  "m8g.8xlarge",
  "c8in.24xlarge",
  "i8ge.24xlarge",
  "r6a.2xlarge",
  "r8gd.xlarge",
  "t1.micro",
  "m6id.xlarge",
  "c8id.24xlarge",
  "m8ib.2xlarge",
  "is4gen.xlarge",
  "m6id.2xlarge",
  "inf2.48xlarge",
  "r6idn.16xlarge",
  "c5ad.24xlarge",
  "i3en.3xlarge",
  "m8idb.2xlarge",
  "r7iz.12xlarge",
  "r5n.12xlarge",
  "m8g.24xlarge",
  "x1e.2xlarge",
  "m8gb.2xlarge",
  "r8g.metal-24xl",
  "c7a.medium",
  "r5a.2xlarge",
  "c6in.24xlarge",
  "m5.8xlarge",
  "r5.24xlarge",
  "c8id.96xlarge",
  "hpc7g.4xlarge",
  "m7g.4xlarge",
  "r6g.large",
  "r6in.12xlarge",
  "r8i-flex.8xlarge",
  "m8g.metal-48xl",
  "r8gb.4xlarge",
  "g5.2xlarge",
  "i3en.24xlarge",
  "m7gd.xlarge",
  "r8id.96xlarge",
  "m8azn.12xlarge",
  "r6id.xlarge",
  "m5dn.12xlarge",
  "i8ge.12xlarge",
  "i2.2xlarge",
  "x8g.48xlarge",
  "r3.large",
  "r8gn.12xlarge",
  "c6gd.metal",
  "z1d.2xlarge",
  "m8a.12xlarge",
  "m8a.medium",
  "g6e.48xlarge",
  "m7gd.16xlarge",
  "c8ib.4xlarge",
  "m7g.large",
  "i4i.24xlarge",
  "r6id.2xlarge",
  "m8gb.24xlarge",
  "m8id.96xlarge",
  "m8id.24xlarge",
  "c8g.2xlarge",
  "r6idn.2xlarge",
  "m5ad.12xlarge",
  "m8a.48xlarge",
  "i8g.metal-48xl",
  "i3en.12xlarge",
  "i4g.xlarge",
  "c8ib.8xlarge",
  "r8id.8xlarge",
  "c8i.8xlarge",
  "r7iz.8xlarge",
  "x2gd.8xlarge",
  "m5d.8xlarge",
  "r5a.xlarge",
  "c6i.4xlarge",
  "r7a.32xlarge",
  "m6gd.xlarge",
  "r8id.48xlarge",
  "c4.4xlarge",
  "c6in.xlarge",
  "c8i-flex.8xlarge",
  "im4gn.8xlarge",
  "m4.4xlarge",
  "c8in.48xlarge",
  "c6a.48xlarge",
  "c8id.2xlarge",
  "c7g.8xlarge",
  "m8i.12xlarge",
  "c6g.16xlarge",
  "c8ine.4xlarge",
  "m7i.16xlarge",
  "c7gn.xlarge",
  "c6id.8xlarge",
  "r8gd.8xlarge",
  "r6gd.xlarge",
  "c7a.metal-48xl",
  "g5.4xlarge",
  "m5dn.2xlarge",
  "c5n.2xlarge",
  "m6gd.medium",
  "c5d.large",
  "c8gd.xlarge",
  "trn1n.32xlarge",
  "m6i.large",
  "is4gen.4xlarge",
  "x8i.96xlarge",
  "r8g.16xlarge",
  "m5dn.large",
  "x8g.24xlarge",
  "m6a.large",
  "r8gn.medium",
  "r6g.8xlarge",
  "c6i.large",
  "c8ib.metal-96xl",
  "m5a.4xlarge",
  "i7ie.18xlarge",
  "g6f.2xlarge",
  "i7ie.xlarge",
  "m7i.24xlarge",
  "d2.8xlarge",
  "im4gn.2xlarge",
  "i8ge.18xlarge",
  "c7gn.large",
  "r6id.12xlarge",
  "m5ad.4xlarge",
  "r7i.metal-48xl",
  "r8g.medium",
  "m6i.24xlarge",
  "m6idn.4xlarge",
  "c8a.medium",
  "c8id.16xlarge",
  "m8gb.8xlarge",
  "r8i.24xlarge",
  "c6i.2xlarge",
  "c8gd.4xlarge",
  "c4.8xlarge",
  "r8i.32xlarge",
  "m8id.2xlarge",
  "r6gd.large",
  "c7i-flex.2xlarge",
  "m5.12xlarge",
  "r8idb.2xlarge",
  "m5ad.large",
  "m6idn.12xlarge",
  "r5ad.24xlarge",
  "r7gd.8xlarge",
  "c5n.large",
  "c8g.24xlarge",
  "r8g.large",
  "c7i-flex.8xlarge",
  "r7g.medium",
  "c7a.large",
  "c5ad.4xlarge",
  "x8g.large",
  "trn1.2xlarge",
  "x1.16xlarge",
  "m6id.32xlarge",
  "c8g.8xlarge",
  "r7iz.xlarge",
  "c8gd.2xlarge",
  "x2iedn.xlarge",
  "m5.24xlarge",
  "r6idn.8xlarge",
  "t3a.2xlarge",
  "c7i-flex.16xlarge",
  "c6id.24xlarge",
  "r8a.8xlarge",
  "m5zn.large",
  "m6id.12xlarge",
  "c7gn.8xlarge",
  "c6a.32xlarge",
  "inf2.8xlarge",
  "r8ib.96xlarge",
  "c7g.16xlarge",
  "m5zn.6xlarge",
  "x1e.32xlarge",
  "i7i.2xlarge",
  "r8gb.metal-48xl",
  "r7iz.32xlarge",
  "r7a.4xlarge",
  "c8gn.16xlarge",
  "c7i.8xlarge",
  "c8id.4xlarge",
  "c5ad.12xlarge",
  "c5.4xlarge",
  "inf1.xlarge",
  "c6gn.xlarge",
  "m7i.2xlarge",
  "r8a.medium",
  "m8in.xlarge",
  "g7e.8xlarge",
  "m7a.xlarge",
  "m7i.8xlarge",
  "m8idb.32xlarge",
  "r6idn.xlarge",
  "m8gn.24xlarge",
  "m8i.16xlarge",
  "c8in.large",
  "c8ib.48xlarge",
  "m8id.48xlarge",
  "m8gb.metal-48xl",
  "x8i.16xlarge",
  "g7e.2xlarge",
  "r5b.12xlarge",
  "r8i.16xlarge",
  "i7i.12xlarge",
  "r3.8xlarge",
  "m8id.large",
  "c5d.12xlarge",
  "m8ine.12xlarge",
  "m8idb.4xlarge",
  "c6i.8xlarge",
  "m7i-flex.2xlarge",
  "r8idb.48xlarge",
  "m8g.large",
  "r4.16xlarge",
  "r8ib.16xlarge",
  "i4g.8xlarge",
  "r8idn.8xlarge",
  "r8i.large",
  "d3en.8xlarge",
  "r8gn.2xlarge",
  "m8idn.xlarge",
  "i7i.xlarge",
  "m6gd.metal",
  "r7gd.16xlarge",
  "c6id.large",
  "c8gn.8xlarge",
  "c6gn.4xlarge",
  "x2idn.24xlarge",
  "r8gd.medium",
  "c7a.2xlarge",
  "r6i.4xlarge",
  "r7gd.xlarge",
  "t4g.medium",
  "d2.2xlarge",
  "c7a.4xlarge",
  "g6.8xlarge",
  "r8idb.8xlarge",
  "m6in.16xlarge",
  "r5a.12xlarge",
  "r8idb.24xlarge",
  "m8a.xlarge",
  "t3.2xlarge",
  "r8gd.16xlarge",
  "r8i.12xlarge",
  "a1.medium",
  "r8id.32xlarge",
  "r6in.large",
  "r8id.xlarge",
  "g4ad.8xlarge",
  "m6g.metal",
  "c8a.16xlarge",
  "x2gd.4xlarge",
  "r6idn.24xlarge",
  "i4g.large",
  "m8i-flex.2xlarge",
  "c5a.4xlarge",
  "m7g.12xlarge",
  "r7a.medium",
  "m8gd.8xlarge",
  "r5ad.12xlarge",
  "c8i.large",
  "m6i.8xlarge",
  "g4ad.4xlarge",
  "m5d.large",
  "m8gn.4xlarge",
  "g7e.48xlarge",
  "r7i.16xlarge",
  "r7a.large",
  "r8idb.32xlarge",
  "m7a.16xlarge",
  "m6in.32xlarge",
  "c8gd.24xlarge",
  "c7gd.16xlarge",
  "m5dn.xlarge",
  "m6a.metal",
  "c8in.8xlarge",
  "m7gd.12xlarge",
  "g7e.4xlarge",
  "r5b.metal",
  "c5ad.16xlarge",
  "i8ge.48xlarge",
  "r5a.large",
  "c8gd.metal-48xl",
  "r8idn.xlarge",
  "r6id.4xlarge",
  "m5dn.8xlarge",
  "m5.xlarge",
  "c6in.12xlarge",
  "x2iezn.8xlarge",
  "x8i.8xlarge",
  "mac-m4pro.metal",
  "t3.xlarge",
  "r5ad.8xlarge",
  "c6g.12xlarge",
  "c6g.xlarge",
  "r8id.4xlarge",
  "m6in.24xlarge",
  "m5d.metal",
  "m7a.32xlarge",
  "i7ie.3xlarge",
  "c8g.metal-48xl",
  "i4i.metal",
  "c8in.xlarge",
  "m6g.xlarge",
  "m8idn.96xlarge",
  "m5d.16xlarge",
  "i7i.large",
  "m6in.12xlarge",
  "g4dn.metal",
  "c8i-flex.2xlarge",
  "c7g.4xlarge",
  "m5.metal",
  "im4gn.xlarge",
  "c6i.24xlarge",
  "r6i.24xlarge",
  "m5ad.8xlarge",
  "m8ib.xlarge",
  "r8gn.48xlarge",
  "hpc7g.8xlarge",
  "i7ie.12xlarge",
  "r7g.xlarge",
  "c7a.8xlarge",
  "r6a.32xlarge",
  "m8idn.16xlarge",
  "g7e.12xlarge",
  "g4dn.12xlarge",
  "m8gd.2xlarge",
  "m8ib.large",
  "c4.large",
  "x8i.4xlarge",
  "m8gn.metal-24xl",
  "c8ib.large",
  "m8gn.2xlarge",
  "u7i-12tb.224xlarge",
  "t3.medium",
  "c8ine.12xlarge",
  "z1d.xlarge",
  "m8azn.large",
  "i8g.4xlarge",
  "x2iedn.metal",
  "c6id.16xlarge",
  "t2.large",
  "x8i.2xlarge",
  "r6a.12xlarge",
  "d3.8xlarge",
  "x2gd.medium",
  "m8g.16xlarge",
  "c5.xlarge",
  "r6a.8xlarge",
  "c5a.12xlarge",
  "i8g.8xlarge",
  "u-3tb1.56xlarge",
  "m5n.8xlarge",
  "g4ad.2xlarge",
  "c8gb.large",
  "t3.large",
  "r6gd.metal",
  "c8i.24xlarge",
  "c8gb.8xlarge",
  "c8in.32xlarge",
  "inf2.24xlarge",
  "h1.8xlarge",
  "a1.large",
  "c7g.xlarge",
  "m4.xlarge",
  "i7ie.metal-48xl",
  "r5n.4xlarge",
  "r8idb.large",
  "c8i-flex.16xlarge",
  "m2.2xlarge",
  "g6e.16xlarge",
  "r7g.metal",
  "c8i.96xlarge",
  "mac1.metal",
  "t3a.small",
  "x8i.32xlarge",
  "i8ge.3xlarge",
  "p4de.24xlarge",
  "g5g.2xlarge",
  "c5n.4xlarge",
  "x8i.64xlarge",
  "m8a.16xlarge",
  "c1.xlarge",
  "m8ib.4xlarge",
  "c6in.16xlarge",
  "c6i.16xlarge",
  "r6g.4xlarge",
  "a1.xlarge",
  "m8idn.12xlarge",
  "r8i.2xlarge",
  "r8gn.large",
  "m8in.32xlarge",
  "g5.24xlarge",
  "c5n.9xlarge",
  "r8gd.4xlarge",
  "r8id.metal-96xl",
  "r5a.16xlarge",
  "r8i.96xlarge",
  "c5a.xlarge",
  "r7iz.metal-16xl",
  "t4g.2xlarge",
  "m8idb.48xlarge",
  "c6gn.12xlarge",
  "r8idb.96xlarge",
  "m8gn.metal-48xl",
  "c7i.metal-24xl",
  "r7g.2xlarge",
  "c8gb.medium",
  "m7g.16xlarge",
  "g6.48xlarge",
  "c5d.2xlarge",
  "m5ad.2xlarge",
  "r5b.large",
  "x2gd.16xlarge",
  "r5.large",
  "i4i.4xlarge",
  "c5ad.xlarge",
  "c8i.4xlarge",
  "c8gd.metal-24xl",
  "mac2.metal",
  "r7i.2xlarge",
  "r3.2xlarge",
  "t3a.medium",
  "r5d.4xlarge",
  "g5g.16xlarge",
  "r7gd.medium",
  "i4g.4xlarge",
  "vt1.6xlarge",
  "c5.12xlarge",
  "m8a.large",
  "c7i-flex.4xlarge",
  "m8ine.2xlarge",
  "d3en.4xlarge",
  "c5d.24xlarge",
  "r6g.12xlarge",
  "c7i.large",
  "r3.4xlarge",
  "c1.medium",
  "m6i.16xlarge",
  "c6in.8xlarge",
  "c8g.large",
  "c7i.xlarge",
  "r5.metal",
  "r7i.12xlarge",
  "c6gn.medium",
  "m7gd.8xlarge",
  "m7gd.medium",
  "r8i-flex.2xlarge",
  "m8i-flex.16xlarge",
  "c6a.12xlarge",
  "r5a.4xlarge",
  "c5a.2xlarge",
  "inf1.6xlarge",
  "c8gn.2xlarge",
  "c6gd.16xlarge",
  "c8gn.12xlarge",
  "r5ad.large",
  "m8idn.32xlarge",
  "r8ib.48xlarge",
  "t2.micro",
  "p6-b200.48xlarge",
  "i8g.24xlarge",
  "r6id.32xlarge",
  "m6i.metal",
  "c7gd.large",
  "m8in.48xlarge",
  "m8gn.16xlarge",
  "h1.2xlarge",
  "u7in-24tb.224xlarge",
  "i7ie.48xlarge",
  "r8idn.12xlarge",
  "c6a.8xlarge",
  "m5n.12xlarge",
  "r8a.48xlarge",
  "c8in.metal-96xl",
  "r6gd.4xlarge",
  "c7i-flex.xlarge",
  "g6e.12xlarge",
  "inf1.2xlarge",
  "r8ib.12xlarge",
  "m6idn.xlarge",
  "vt1.3xlarge",
  "m6gd.16xlarge",
  "i8g.metal-24xl",
  "m7i.48xlarge",
  "r8idn.24xlarge",
  "c5a.24xlarge",
  "m8id.metal-96xl",
  "r5dn.xlarge",
  "g5.12xlarge",
  "i4i.2xlarge",
  "x2gd.2xlarge",
  "i4g.2xlarge",
  "r7i.8xlarge",
  "r8gb.large",
  "m7g.8xlarge",
  "x8i.large",
  "m8ib.24xlarge",
  "c8gn.xlarge",
  "c6g.large",
  "r5b.24xlarge",
  "r8i.xlarge",
  "m5zn.3xlarge",
  "m8i.xlarge",
  "d3.xlarge",
  "m4.large",
  "r8id.2xlarge",
  "d3.2xlarge",
  "c7a.12xlarge",
  "r5dn.large",
  "r5.4xlarge",
  "r8a.metal-24xl",
  "r8in.large",
  "u-6tb1.56xlarge",
  "c7i.16xlarge",
  "x8i.24xlarge",
  "c8ine.8xlarge",
  "c6in.2xlarge",
  "x8g.metal-48xl",
  "r5n.16xlarge",
  "m8i.32xlarge",
  "u7in-16tb.224xlarge",
  "c6a.metal",
  "c8i-flex.4xlarge",
  "m7gd.metal",
  "h1.4xlarge",
  "r8g.24xlarge",
  "c8a.large",
  "m6i.32xlarge",
  "r8in.4xlarge",
  "c7gd.xlarge",
  "r5b.2xlarge",
  "x2gd.xlarge",
  "r8in.2xlarge",
  "m6idn.32xlarge",
  "m5n.large",
  "r8g.48xlarge",
  "r8idn.large",
  "r8in.12xlarge",
  "r5b.xlarge",
  "i4g.16xlarge",
  "r6a.48xlarge",
  "r5n.24xlarge",
  "m1.xlarge",
  "d3en.6xlarge",
  "c7i-flex.12xlarge",
  "m8in.4xlarge",
  "c8gb.24xlarge",
  "c3.xlarge",
  "c8id.48xlarge",
  "m8g.4xlarge",
  "r5n.2xlarge",
  "r5d.2xlarge",
  "c8gn.48xlarge",
  "m8gn.12xlarge",
  "m8gd.12xlarge",
  "m8g.xlarge",
  "r5d.large",
  "r5dn.metal",
  "c8gd.medium",
  "m8a.metal-48xl",
  "r5d.16xlarge",
  "r8gd.large",
  "p5.48xlarge",
  "r7i.metal-24xl",
  "m6in.metal",
  "c8a.xlarge",
  "m5n.4xlarge",
  "c7i-flex.large",
  "m8idn.48xlarge",
  "r5b.4xlarge",
  "c8gb.xlarge",
  "m6g.8xlarge",
  "m8i.8xlarge",
  "r5d.xlarge",
  "t4g.small",
  "m3.xlarge",
  "c7gn.metal",
  "r8gb.12xlarge",
  "c5d.4xlarge",
  "c8gb.16xlarge",
  "c5.24xlarge",
  "m6a.4xlarge",
  "c8a.metal-24xl",
  "r6id.24xlarge",
  "m6g.large",
  "i7i.metal-24xl",
  "m8in.24xlarge",
  "x8i.metal-96xl",
  "r8a.metal-48xl",
  "m5zn.12xlarge",
  "c8i.16xlarge",
  "m6in.4xlarge",
  "p4d.24xlarge",
  "r7gd.4xlarge",
  "r8in.32xlarge",
  "r5.16xlarge",
  "m7a.medium",
  "r7iz.2xlarge",
  "c8gb.12xlarge",
  "m7gd.4xlarge",
  "r8idn.2xlarge",
  "c7i.24xlarge",
  "m8azn.6xlarge",
  "hpc7g.16xlarge",
  "m5.4xlarge",
  "r6in.32xlarge",
  "i2.xlarge",
  "x8g.metal-24xl",
  "i7ie.metal-24xl",
  "c8gb.4xlarge",
  "c6gd.xlarge",
  "m8id.xlarge",
  "m5n.metal",
  "m6g.4xlarge",
  "t4g.large",
  "m4.16xlarge",
  "m8idb.xlarge",
  "i8g.2xlarge",
  "r8ib.24xlarge",
  "c7a.16xlarge",
  "r6a.4xlarge",
  "c7g.medium",
  "c8in.12xlarge",
  "m6id.metal",
  "c4.2xlarge",
  "i7i.16xlarge",
  "m6a.16xlarge",
  "c8in.96xlarge",
  "c8gb.metal-48xl",
  "c7g.2xlarge",
  "r8gd.24xlarge",
  "g5g.8xlarge",
  "m8idn.4xlarge",
  "i4i.large",
  "r6in.4xlarge",
  "c8in.metal-48xl",
  "r6i.16xlarge",
  "m8gd.large",
  "m5zn.metal",
  "m5dn.metal",
  "t3.nano",
  "c8gd.12xlarge",
  "t3.micro",
  "i8ge.xlarge",
  "c6in.large",
  "r8i-flex.4xlarge",
  "i7i.4xlarge",
  "r6idn.large",
  "r8in.8xlarge",
  "x2iedn.4xlarge",
  "r7i.xlarge",
  "m6id.16xlarge",
  "r7a.24xlarge",
  "r8gd.metal-24xl",
  "m8gb.12xlarge",
  "m6i.4xlarge",
  "m5a.8xlarge",
  "r7gd.2xlarge",
  "c5.metal",
  "h1.16xlarge",
  "r8idb.16xlarge",
  "c8i.48xlarge",
  "r8gn.16xlarge",
  "r5d.24xlarge",
  "i8g.large",
  "m8i.2xlarge",
  "c7i.metal-48xl",
  "c5n.18xlarge",
  "a1.metal",
  "c4.xlarge",
  "m8g.12xlarge",
  "m8ib.12xlarge",
  "c7a.24xlarge",
  "r7gd.metal",
  "c8ib.12xlarge",
  "r3.xlarge",
  "r8a.xlarge",
  "x8g.medium",
  "m8ib.96xlarge",
  "c8a.48xlarge",
  "r8idn.32xlarge",
  "c5ad.2xlarge",
  "m8gn.medium",
  "p5.4xlarge",
  "r8gb.16xlarge",
  "c8g.12xlarge",
  "r6idn.4xlarge",
  "r4.2xlarge",
  "m7i-flex.16xlarge",
  "m8gd.24xlarge",
  "c8i.12xlarge",
  "is4gen.2xlarge",
  "m7g.xlarge",
  "m7a.24xlarge",
  "m6idn.2xlarge",
  "c5.9xlarge",
  "r8in.48xlarge",
  "i8g.xlarge",
  "r7g.4xlarge",
  "u-6tb1.112xlarge",
  "t4g.micro",
  "i8ge.metal-24xl",
  "x2iezn.12xlarge",
  "r7gd.large",
  "c6id.32xlarge",
  "x2gd.12xlarge",
  "r4.xlarge",
  "i3.xlarge",
  "c8ib.2xlarge",
  "x2idn.metal",
  "r5ad.2xlarge",
  "mac-m4max.metal",
  "r7g.8xlarge",
  "r8idb.4xlarge",
  "c5d.18xlarge",
  "g5g.metal",
  "m5d.24xlarge",
  "m7a.48xlarge",
  "c6a.xlarge",
  "r5ad.16xlarge",
  "m8gd.48xlarge",
  "is4gen.large",
  "i2.4xlarge",
  "c8in.4xlarge",
  "m5.16xlarge",
  "m4.2xlarge",
  "x2iedn.16xlarge",
  "r8gb.medium",
  "c7gd.2xlarge",
  "m8idb.96xlarge",
  "m6idn.24xlarge",
  "m5ad.24xlarge",
  "c8g.metal-24xl",
  "m5ad.xlarge",
  "c7a.32xlarge",
  "a1.2xlarge",
  "r6gd.8xlarge",
  "r5d.8xlarge",
  "m8in.12xlarge",
  "c8gb.metal-24xl",
  "m8gd.medium",
  "c5a.16xlarge",
  "r5dn.12xlarge",
  "z1d.metal",
  "m3.2xlarge",
  "m8i.48xlarge",
  "m8azn.metal-12xl",
  "r6i.12xlarge",
  "m8id.8xlarge",
  "c7gd.8xlarge",
  "c5n.metal",
  "i7i.metal-48xl",
  "z1d.12xlarge",
  "r5b.16xlarge",
  "r6in.8xlarge",
  "t2.medium",
  "m6g.12xlarge",
  "r8gn.4xlarge",
  "m7a.4xlarge",
  "r8idn.96xlarge",
  "c6id.metal",
  "r8i.4xlarge",
  "m7i-flex.4xlarge",
  "m8in.2xlarge",
  "c6in.32xlarge",
  "r7i.large",
  "r6a.24xlarge",
  "i2.8xlarge",
  "i8g.48xlarge",
  "c8a.4xlarge",
  "r6id.large",
  "r8idb.12xlarge",
  "c8id.xlarge",
  "m7g.2xlarge",
  "c7g.metal",
  "inf2.xlarge",
  "m8azn.xlarge",
  "c5.large",
  "r8gn.xlarge",
  "u7i-8tb.112xlarge",
  "x8g.4xlarge",
  "c8gd.8xlarge",
  "x1e.16xlarge",
  "g6.2xlarge",
  "m6in.xlarge",
  "c3.4xlarge",
  "r8a.24xlarge",
  "t3a.large",
  "r5.2xlarge",
  "c8in.16xlarge",
  "r5.8xlarge",
  "c6a.4xlarge",
  "r7a.metal-48xl",
  "m6idn.metal",
  "c8a.8xlarge",
  "r8gb.48xlarge",
  "mac2-m1ultra.metal",
  "m8idb.8xlarge",
  "m8i.4xlarge",
  "g6.xlarge",
  "m6in.large",
  "r8a.12xlarge",
  "m8ib.48xlarge",
  "r5.xlarge",
  "c8gn.metal-24xl",
  "m7a.8xlarge",
  "r5dn.16xlarge",
  "g5.16xlarge",
  "g4dn.xlarge",
  "x2gd.large",
  "i3.large",
  "c7a.48xlarge",
  "m6g.16xlarge",
  "x2idn.16xlarge",
  "x8g.12xlarge",
  "c8a.24xlarge",
  "t4g.xlarge",
  "mac-m4.metal",
  "m7a.12xlarge",
  "m8ine.xlarge",
  "i3.8xlarge",
  "g6.16xlarge",
  "c8gd.16xlarge",
  "c8i.xlarge",
  "r8i.metal-96xl",
  "i3.16xlarge",
  "t2.xlarge",
  "c6id.12xlarge",
  "m8gd.16xlarge",
  "r8ib.32xlarge",
  "vt1.24xlarge",
  "x8g.8xlarge",
  "x8g.16xlarge",
  "c6in.4xlarge",
  "r8gd.metal-48xl",
  "r8idn.16xlarge",
  "c8i-flex.xlarge",
  "g6f.large",
  "r7a.8xlarge",
  "r8g.metal-48xl",
  "r8a.16xlarge",
  "r6i.metal",
  "c6gn.8xlarge",
  "r6id.metal",
  "r6id.8xlarge",
  "m8id.12xlarge",
  "c6gn.2xlarge",
  "i7i.8xlarge",
  "im4gn.large",
  "m7g.medium",
  "c7g.large",
  "c5d.xlarge",
  "z1d.6xlarge",
  "m8g.48xlarge",
  "c8id.large",
  "m5.2xlarge",
  "x2iezn.2xlarge",
  "i8g.16xlarge",
  "m6gd.8xlarge",
  "x2iezn.metal",
  "z1d.large",
  "g5.xlarge",
  "c8ine.large",
  "m5dn.24xlarge",
  "x8i.metal-48xl",
  "g6.12xlarge",
  "m5dn.4xlarge",
  "r6idn.32xlarge",
  "m8idn.8xlarge",
  "m8g.2xlarge",
  "m8id.metal-48xl",
  "x2idn.32xlarge",
  "c6gn.large",
  "m6id.4xlarge",
  "c3.2xlarge",
  "f2.48xlarge",
  "r5n.xlarge",
  "m8gd.xlarge",
  "m5n.24xlarge",
  "r6gd.16xlarge",
  "m5n.xlarge",
  "c8gb.2xlarge",
  "m8a.metal-24xl",
  "c5d.metal",
  "x8i.xlarge",
  "m8a.2xlarge",
  "m7i.large",
  "m5d.12xlarge",
  "m7g.metal",
  "c8id.12xlarge",
  "r6a.16xlarge",
  "m4.10xlarge",
  "c5.2xlarge",
  "r8gn.metal-48xl",
  "r5ad.xlarge",
  "r8g.xlarge",
  "r6idn.metal",
  "r8gn.24xlarge",
  "i8ge.metal-48xl",
  "c7i.4xlarge",
  "m5.large",
  "c8gn.large",
  "c8g.medium",
  "m8gb.16xlarge",
  "r8i.metal-48xl",
  "r6in.16xlarge",
  "m5zn.xlarge",
  "r8in.96xlarge",
  "m8azn.medium",
  "a1.4xlarge",
  "m5dn.16xlarge",
  "c7gd.metal",
  "r5d.metal",
  "c7gd.12xlarge",
  "mac2-m2pro.metal",
  "im4gn.4xlarge",
  "m5d.2xlarge",
  "m8i.metal-96xl",
  "p5en.48xlarge",
  "m5a.large",
  "g4ad.16xlarge",
  "m8gn.8xlarge",
  "r8gd.12xlarge",
  "m8gb.48xlarge",
  "r5dn.2xlarge",
  "m6idn.16xlarge",
  "r8id.12xlarge",
  "g6e.4xlarge",
  "g6e.2xlarge",
  "r5n.8xlarge",
  "c6g.4xlarge",
  "c6id.xlarge",
  "m8i-flex.4xlarge",
  "d2.4xlarge",
  "m7i.xlarge",
  "c8g.xlarge",
  "i4i.12xlarge",
  "c7i.12xlarge",
  "c8ine.2xlarge",
  "c6gd.medium",
  "r7i.24xlarge",
  "m8i.large",
  "r8gb.xlarge",
  "c8id.metal-48xl",
  "g6f.4xlarge",
  "r8id.metal-48xl",
  "m5n.2xlarge",
  "i3en.large",
  "dl1.24xlarge",
  "r8in.24xlarge",
  "m8in.large",
  "c7g.12xlarge",
  "c8gn.medium",
  "m8a.4xlarge",
  "t3.small",
  "g4dn.16xlarge",
  "i3en.xlarge",
  "im4gn.16xlarge",
  "r7iz.metal-32xl",
  "m6idn.8xlarge",
  "r8gb.2xlarge",
  "r5b.8xlarge",
  "c5ad.8xlarge",
  "r8g.2xlarge",
  "m8azn.24xlarge",
  "x1e.xlarge",
  "r6g.xlarge",
  "m8g.metal-24xl",
  "r8i-flex.12xlarge",
  "d3.4xlarge",
  "m6i.xlarge",
  "c6g.medium",
  "r5a.8xlarge",
  "m7i-flex.8xlarge",
  "m8i.24xlarge",
  "g6.4xlarge",
  "c6i.metal",
  "gr6.8xlarge",
  "x2iezn.6xlarge",
  "r8idn.48xlarge",
  "m8idn.24xlarge",
  "c8g.4xlarge",
  "r5.12xlarge",
  "c7gn.12xlarge",
  "c6a.2xlarge",
  "c8gd.large",
  "gr6.4xlarge",
  "r4.large",
  "r5a.24xlarge",
  "m8gn.48xlarge",
  "x8i.12xlarge",
  "i4i.32xlarge",
  "g6e.xlarge",
  "m8ine.4xlarge",
  "i4i.xlarge",
  "r8ib.large",
  "r7g.large",
  "c8in.2xlarge",
  "r8gn.metal-24xl",
  "m8i-flex.12xlarge",
  "m5ad.16xlarge",
  "m8ine.large",
  "t2.small",
  "c5a.8xlarge",
  "r4.8xlarge",
  "i3en.2xlarge",
  "m7a.2xlarge",
  "m8idb.large",
  "r7gd.12xlarge",
  "m6a.24xlarge",
  "r5d.12xlarge",
  "m8gd.metal-24xl",
  "c8i.metal-96xl",
  "r6a.large",
  "c6gd.2xlarge",
  "c5ad.large",
  "x2iedn.24xlarge",
  "r5ad.4xlarge",
  "inf1.24xlarge",
  "c8a.12xlarge",
  "f2.12xlarge",
  "r7i.48xlarge",
  "m6a.xlarge",
  "i8ge.large",
  "i8g.12xlarge",
  "is4gen.medium",
  "m8id.32xlarge",
  "c6i.xlarge",
  "c8i.32xlarge",
  "r6idn.12xlarge",
  "m6id.large",
  "m6gd.2xlarge",
  "r6gd.12xlarge",
  "c6g.2xlarge",
  "i3.2xlarge",
  "m7a.metal-48xl",
  "c7gn.2xlarge",
  "c7gd.4xlarge",
  "m6a.32xlarge",
  "m8ib.32xlarge",
  "r8in.16xlarge",
  "r4.4xlarge",
  "r8idn.4xlarge",
  "r8idb.xlarge",
  "gr6f.4xlarge",
  "i7i.24xlarge",
  "c6id.2xlarge",
  "m7i.12xlarge",
  "m8i-flex.xlarge",
  "c6i.12xlarge",
  "x1e.4xlarge",
  "i7ie.6xlarge",
  "u7in-32tb.224xlarge",
  "m6a.8xlarge",
  "m8in.96xlarge",
  "r7a.16xlarge",
  "r8i-flex.xlarge",
  "c6g.8xlarge",
  "m3.medium",
  "r6in.xlarge",
  "r6i.8xlarge",
  "m6gd.large",
  "r8ib.4xlarge",
  "c8i-flex.12xlarge",
  "r8gb.24xlarge",
  "x8g.xlarge",
  "r7g.16xlarge",
  "c8g.16xlarge",
  "r7g.12xlarge",
  "c7gn.4xlarge",
  "m6in.2xlarge",
  "m8idn.large",
  "m8gb.large",
  "x1.32xlarge",
  "i3.4xlarge",
  "t2.nano",
  "r6i.32xlarge",
  "c6id.4xlarge",
  "m8i-flex.large",
  "r8gb.metal-24xl",
  "z1d.3xlarge",
  "c5n.xlarge",
  "r8i-flex.large",
  "i7ie.large",
  "r6g.metal",
  "g5.8xlarge",
  "m6id.24xlarge",
  "m8ib.8xlarge",
  "i8ge.6xlarge",
  "c8gn.24xlarge",
  "x2iedn.32xlarge",
  "m7i-flex.xlarge",
  "r7a.12xlarge",
  "m7i.4xlarge",
  "m2.xlarge",
  "c8ib.metal-48xl",
  "c6gd.4xlarge",
  "m3.large",
  "c7gn.medium",
  "g6f.xlarge",
  "m8g.medium",
  "m5a.24xlarge",
  "m5d.4xlarge",
  "m8gn.xlarge",
  "m6id.8xlarge",
  "i7i.48xlarge",
  "r6g.2xlarge",
  "r7i.4xlarge",
  "m8i.96xlarge",
  "g5.48xlarge",
  "m8ine.8xlarge",
  "m6in.8xlarge",
  "c8gn.metal-48xl",
  "t3a.nano",
  "x2iedn.8xlarge",
  "c8i-flex.large",
  "m7i-flex.large",
  "m5a.xlarge",
  "r5dn.4xlarge",
  "r6i.2xlarge",
  "c5a.large",
  "r8i.8xlarge",
  "d3en.xlarge",
  "t3a.micro",
  "m8gd.4xlarge",
  "c8ib.24xlarge",
  "x8i.48xlarge",
  "mac-m3ultra.metal",
  "m5a.12xlarge",
  "r7iz.large",
  "g4ad.xlarge",
  "c8gb.48xlarge",
  "r8a.4xlarge",
  "r5n.large",
  "c8i.2xlarge",
  "m6g.2xlarge",
  "c8id.metal-96xl",
  "m8idn.2xlarge",
  "m8idb.12xlarge",
  "c8id.32xlarge",
  "r6in.2xlarge",
  "c8ib.96xlarge",
  "m6a.12xlarge",
  "m6g.medium",
  "m6i.12xlarge",
  "i3en.metal",
  "r7a.48xlarge",
  "i4i.8xlarge",
  "r8g.8xlarge",
  "c7i.48xlarge",
  "m8i-flex.8xlarge",
  "t3a.xlarge",
  "c5d.9xlarge",
  "r8id.large",
  "m8id.4xlarge",
  "c8ib.xlarge",
  "c8id.8xlarge",
  "c8ib.16xlarge",
  "p3dn.24xlarge",
  "g5g.4xlarge",
  "r8id.24xlarge",
  "m7gd.2xlarge",
  "p6-b300.48xlarge",
  "r6i.large",
  "i8ge.2xlarge",
  "m7a.large",
  "c8a.metal-48xl",
  "r7iz.4xlarge",
  "r5dn.24xlarge",
  "g7e.24xlarge",
  "c6g.metal",
  "m8gb.4xlarge",
  "c8i.metal-48xl",
  "is4gen.8xlarge",
  "m8a.24xlarge",
  "c5.18xlarge",
  "g4dn.4xlarge",
  "m8i.metal-48xl",
  "i7ie.2xlarge",
  "m6i.2xlarge",
  "i3en.6xlarge",
  "r8gd.2xlarge",
  "r5n.metal",
  "r8ib.8xlarge",
  "m7i.metal-48xl",
  "c6in.metal",
  "c6a.large",
  "m8gb.metal-24xl",
  "c6gd.12xlarge",
  "r8ib.2xlarge",
  "d2.xlarge",
  "g5g.xlarge",
  "r8gn.8xlarge",
  "c6gd.8xlarge",
  "m8in.8xlarge",
  "g4dn.8xlarge",
  "m8idb.24xlarge",
  "d3en.12xlarge",
  "m6a.48xlarge",
  "m1.small",
  "m1.medium",
  "r8i-flex.16xlarge",
  "m8azn.metal-24xl",
  "g6e.24xlarge",
  "r8gd.48xlarge",
  "c6gd.large",
  "g4dn.2xlarge",
  "m1.large"
].sort().map(t => ({ value: t, label: t }));

export const AWS_GRAVITON_INSTANCE_TYPES = [
    "c8g.48xlarge",
    "m8gb.medium",
    "m7gd.large",
    "r6g.medium",
    "m6gd.4xlarge",
    "r6gd.medium",
    "c8gn.4xlarge",
    "r8gb.8xlarge",
    "r6gd.2xlarge",
    "x8g.2xlarge",
    "c8gd.48xlarge",
    "r8g.4xlarge",
    "c7gn.16xlarge",
    "m8gd.metal-48xl",
    "t4g.nano",
    "m8gb.xlarge",
    "c6gn.16xlarge",
    "m6gd.12xlarge",
    "x2gd.metal",
    "c7gd.medium",
    "r8g.12xlarge",
    "m8gn.large",
    "r6g.16xlarge",
    "m8g.8xlarge",
    "i8ge.24xlarge",
    "r8gd.xlarge",
    "is4gen.xlarge",
    "m8g.24xlarge",
    "m8gb.2xlarge",
    "r8g.metal-24xl",
    "hpc7g.4xlarge",
    "m7g.4xlarge",
    "r6g.large",
    "m8g.metal-48xl",
    "r8gb.4xlarge",
    "m7gd.xlarge",
    "i8ge.12xlarge",
    "x8g.48xlarge",
    "r8gn.12xlarge",
    "c6gd.metal",
    "m7gd.16xlarge",
    "m7g.large",
    "m8gb.24xlarge",
    "c8g.2xlarge",
    "i8g.metal-48xl",
    "i4g.xlarge",
    "x2gd.8xlarge",
    "m6gd.xlarge",
    "im4gn.8xlarge",
    "c7g.8xlarge",
    "c6g.16xlarge",
    "c7gn.xlarge",
    "r8gd.8xlarge",
    "r6gd.xlarge",
    "m6gd.medium",
    "c8gd.xlarge",
    "is4gen.4xlarge",
    "r8g.16xlarge",
    "x8g.24xlarge",
    "r8gn.medium",
    "r6g.8xlarge",
    "im4gn.2xlarge",
    "i8ge.18xlarge",
    "c7gn.large",
    "r8g.medium",
    "m8gb.8xlarge",
    "c8gd.4xlarge",
    "r6gd.large",
    "r7gd.8xlarge",
    "c8g.24xlarge",
    "r8g.large",
    "r7g.medium",
    "x8g.large",
    "c8g.8xlarge",
    "c8gd.2xlarge",
    "c7gn.8xlarge",
    "c7g.16xlarge",
    "r8gb.metal-48xl",
    "c8gn.16xlarge",
    "c6gn.xlarge",
    "m8gn.24xlarge",
    "m8gb.metal-48xl",
    "m8g.large",
    "i4g.8xlarge",
    "r8gn.2xlarge",
    "m6gd.metal",
    "r7gd.16xlarge",
    "c8gn.8xlarge",
    "c6gn.4xlarge",
    "r8gd.medium",
    "r7gd.xlarge",
    "t4g.medium",
    "r8gd.16xlarge",
    "m6g.metal",
    "x2gd.4xlarge",
    "i4g.large",
    "m7g.12xlarge",
    "m8gd.8xlarge",
    "m8gn.4xlarge",
    "c8gd.24xlarge",
    "c7gd.16xlarge",
    "m7gd.12xlarge",
    "i8ge.48xlarge",
    "c8gd.metal-48xl",
    "c6g.12xlarge",
    "c6g.xlarge",
    "c8g.metal-48xl",
    "m6g.xlarge",
    "c7g.4xlarge",
    "im4gn.xlarge",
    "r8gn.48xlarge",
    "hpc7g.8xlarge",
    "r7g.xlarge",
    "m8gd.2xlarge",
    "m8gn.metal-24xl",
    "m8gn.2xlarge",
    "i8g.4xlarge",
    "x2gd.medium",
    "m8g.16xlarge",
    "i8g.8xlarge",
    "c8gb.large",
    "r6gd.metal",
    "c8gb.8xlarge",
    "c7g.xlarge",
    "r7g.metal",
    "i8ge.3xlarge",
    "g5g.2xlarge",
    "r6g.4xlarge",
    "r8gn.large",
    "r8gd.4xlarge",
    "t4g.2xlarge",
    "c6gn.12xlarge",
    "m8gn.metal-48xl",
    "r7g.2xlarge",
    "c8gb.medium",
    "m7g.16xlarge",
    "x2gd.16xlarge",
    "c8gd.metal-24xl",
    "g5g.16xlarge",
    "r7gd.medium",
    "i4g.4xlarge",
    "r6g.12xlarge",
    "c8g.large",
    "c6gn.medium",
    "m7gd.8xlarge",
    "m7gd.medium",
    "c8gn.2xlarge",
    "c6gd.16xlarge",
    "c8gn.12xlarge",
    "i8g.24xlarge",
    "c7gd.large",
    "m8gn.16xlarge",
    "r6gd.4xlarge",
    "m6gd.16xlarge",
    "i8g.metal-24xl",
    "x2gd.2xlarge",
    "i4g.2xlarge",
    "r8gb.large",
    "m7g.8xlarge",
    "c8gn.xlarge",
    "c6g.large",
    "x8g.metal-48xl",
    "m7gd.metal",
    "r8g.24xlarge",
    "c7gd.xlarge",
    "x2gd.xlarge",
    "r8g.48xlarge",
    "i4g.16xlarge",
    "c8gb.24xlarge",
    "m8g.4xlarge",
    "c8gn.48xlarge",
    "m8gn.12xlarge",
    "m8gd.12xlarge",
    "m8g.xlarge",
    "c8gd.medium",
    "r8gd.large",
    "c8gb.xlarge",
    "m6g.8xlarge",
    "t4g.small",
    "c7gn.metal",
    "r8gb.12xlarge",
    "c8gb.16xlarge",
    "m6g.large",
    "r7gd.4xlarge",
    "c8gb.12xlarge",
    "m7gd.4xlarge",
    "hpc7g.16xlarge",
    "x8g.metal-24xl",
    "c8gb.4xlarge",
    "c6gd.xlarge",
    "m6g.4xlarge",
    "t4g.large",
    "i8g.2xlarge",
    "c7g.medium",
    "c8gb.metal-48xl",
    "c7g.2xlarge",
    "r8gd.24xlarge",
    "g5g.8xlarge",
    "m8gd.large",
    "c8gd.12xlarge",
    "i8ge.xlarge",
    "r8gd.metal-24xl",
    "m8gb.12xlarge",
    "r7gd.2xlarge",
    "r8gn.16xlarge",
    "i8g.large",
    "m8g.12xlarge",
    "r7gd.metal",
    "x8g.medium",
    "m8gn.medium",
    "r8gb.16xlarge",
    "c8g.12xlarge",
    "m8gd.24xlarge",
    "is4gen.2xlarge",
    "m7g.xlarge",
    "i8g.xlarge",
    "r7g.4xlarge",
    "t4g.micro",
    "i8ge.metal-24xl",
    "r7gd.large",
    "x2gd.12xlarge",
    "r7g.8xlarge",
    "g5g.metal",
    "m8gd.48xlarge",
    "is4gen.large",
    "r8gb.medium",
    "c7gd.2xlarge",
    "c8g.metal-24xl",
    "r6gd.8xlarge",
    "c8gb.metal-24xl",
    "m8gd.medium",
    "c7gd.8xlarge",
    "m6g.12xlarge",
    "r8gn.4xlarge",
    "i8g.48xlarge",
    "m7g.2xlarge",
    "c7g.metal",
    "r8gn.xlarge",
    "x8g.4xlarge",
    "c8gd.8xlarge",
    "r8gb.48xlarge",
    "c8gn.metal-24xl",
    "x2gd.large",
    "m6g.16xlarge",
    "x8g.12xlarge",
    "t4g.xlarge",
    "c8gd.16xlarge",
    "m8gd.16xlarge",
    "x8g.8xlarge",
    "x8g.16xlarge",
    "r8gd.metal-48xl",
    "r8g.metal-48xl",
    "c6gn.8xlarge",
    "c6gn.2xlarge",
    "im4gn.large",
    "m7g.medium",
    "c7g.large",
    "m8g.48xlarge",
    "i8g.16xlarge",
    "m6gd.8xlarge",
    "m8g.2xlarge",
    "c6gn.large",
    "m8gd.xlarge",
    "r6gd.16xlarge",
    "c8gb.2xlarge",
    "m7g.metal",
    "r8gn.metal-48xl",
    "r8g.xlarge",
    "r8gn.24xlarge",
    "i8ge.metal-48xl",
    "c8gn.large",
    "c8g.medium",
    "m8gb.16xlarge",
    "c7gd.metal",
    "c7gd.12xlarge",
    "im4gn.4xlarge",
    "m8gn.8xlarge",
    "r8gd.12xlarge",
    "m8gb.48xlarge",
    "c6g.4xlarge",
    "c8g.xlarge",
    "c6gd.medium",
    "r8gb.xlarge",
    "c7g.12xlarge",
    "c8gn.medium",
    "im4gn.16xlarge",
    "r8gb.2xlarge",
    "r8g.2xlarge",
    "r6g.xlarge",
    "m8g.metal-24xl",
    "c6g.medium",
    "c8g.4xlarge",
    "c7gn.12xlarge",
    "c8gd.large",
    "m8gn.48xlarge",
    "r7g.large",
    "r8gn.metal-24xl",
    "r7gd.12xlarge",
    "m8gd.metal-24xl",
    "c6gd.2xlarge",
    "i8ge.large",
    "i8g.12xlarge",
    "is4gen.medium",
    "m6gd.2xlarge",
    "r6gd.12xlarge",
    "c6g.2xlarge",
    "c7gn.2xlarge",
    "c7gd.4xlarge",
    "c6g.8xlarge",
    "m6gd.large",
    "r8gb.24xlarge",
    "x8g.xlarge",
    "r7g.16xlarge",
    "c8g.16xlarge",
    "r7g.12xlarge",
    "c7gn.4xlarge",
    "m8gb.large",
    "r8gb.metal-24xl",
    "r6g.metal",
    "i8ge.6xlarge",
    "c8gn.24xlarge",
    "c6gd.4xlarge",
    "c7gn.medium",
    "m8g.medium",
    "m8gn.xlarge",
    "r6g.2xlarge",
    "c8gn.metal-48xl",
    "m8gd.4xlarge",
    "c8gb.48xlarge",
    "m6g.2xlarge",
    "m6g.medium",
    "r8g.8xlarge",
    "g5g.4xlarge",
    "m7gd.2xlarge",
    "i8ge.2xlarge",
    "c6g.metal",
    "m8gb.4xlarge",
    "is4gen.8xlarge",
    "r8gd.2xlarge",
    "m8gb.metal-24xl",
    "c6gd.12xlarge",
    "g5g.xlarge",
    "r8gn.8xlarge",
    "c6gd.8xlarge",
    "r8gd.48xlarge",
    "c6gd.large"
].sort().map(t => ({ value: t, label: t }));

export const AWS_NONGRAVITON_INSTANCE_TYPES = [
    "r6in.metal",
    "m8a.8xlarge",
    "m6a.2xlarge",
    "m5d.xlarge",
    "c6a.16xlarge",
    "g6e.8xlarge",
    "m6idn.large",
    "r7a.xlarge",
    "c3.8xlarge",
    "i4i.16xlarge",
    "r7a.2xlarge",
    "m8azn.3xlarge",
    "trn1.32xlarge",
    "r6a.xlarge",
    "r5dn.8xlarge",
    "r6in.24xlarge",
    "c6a.24xlarge",
    "m8id.16xlarge",
    "m5a.16xlarge",
    "c8ib.32xlarge",
    "m5n.16xlarge",
    "m8idb.16xlarge",
    "mac2-m2.metal",
    "r7iz.16xlarge",
    "r8i.48xlarge",
    "m7i-flex.12xlarge",
    "r8ib.xlarge",
    "m2.4xlarge",
    "f2.6xlarge",
    "r8a.large",
    "c8a.2xlarge",
    "m7i.metal-24xl",
    "x2iedn.2xlarge",
    "m5a.2xlarge",
    "m8ib.16xlarge",
    "t2.2xlarge",
    "c3.large",
    "r6a.metal",
    "i7ie.24xlarge",
    "x1e.8xlarge",
    "c7a.xlarge",
    "c8ine.xlarge",
    "u7i-6tb.112xlarge",
    "d3en.2xlarge",
    "r6i.xlarge",
    "m8in.16xlarge",
    "r8id.16xlarge",
    "r8in.xlarge",
    "g6.24xlarge",
    "c6i.32xlarge",
    "m5zn.2xlarge",
    "r8a.2xlarge",
    "c7i.2xlarge",
    "x2iezn.4xlarge",
    "r6id.16xlarge",
    "c8in.24xlarge",
    "r6a.2xlarge",
    "t1.micro",
    "m6id.xlarge",
    "c8id.24xlarge",
    "m8ib.2xlarge",
    "m6id.2xlarge",
    "inf2.48xlarge",
    "r6idn.16xlarge",
    "c5ad.24xlarge",
    "i3en.3xlarge",
    "m8idb.2xlarge",
    "r7iz.12xlarge",
    "r5n.12xlarge",
    "x1e.2xlarge",
    "c7a.medium",
    "r5a.2xlarge",
    "c6in.24xlarge",
    "m5.8xlarge",
    "r5.24xlarge",
    "c8id.96xlarge",
    "r6in.12xlarge",
    "r8i-flex.8xlarge",
    "g5.2xlarge",
    "i3en.24xlarge",
    "r8id.96xlarge",
    "m8azn.12xlarge",
    "r6id.xlarge",
    "m5dn.12xlarge",
    "i2.2xlarge",
    "r3.large",
    "z1d.2xlarge",
    "m8a.12xlarge",
    "m8a.medium",
    "g6e.48xlarge",
    "c8ib.4xlarge",
    "i4i.24xlarge",
    "r6id.2xlarge",
    "m8id.96xlarge",
    "m8id.24xlarge",
    "r6idn.2xlarge",
    "m5ad.12xlarge",
    "m8a.48xlarge",
    "i3en.12xlarge",
    "c8ib.8xlarge",
    "r8id.8xlarge",
    "c8i.8xlarge",
    "r7iz.8xlarge",
    "m5d.8xlarge",
    "r5a.xlarge",
    "c6i.4xlarge",
    "r7a.32xlarge",
    "r8id.48xlarge",
    "c4.4xlarge",
    "c6in.xlarge",
    "c8i-flex.8xlarge",
    "m4.4xlarge",
    "c8in.48xlarge",
    "c6a.48xlarge",
    "c8id.2xlarge",
    "m8i.12xlarge",
    "c8ine.4xlarge",
    "m7i.16xlarge",
    "c6id.8xlarge",
    "c7a.metal-48xl",
    "g5.4xlarge",
    "m5dn.2xlarge",
    "c5n.2xlarge",
    "c5d.large",
    "trn1n.32xlarge",
    "m6i.large",
    "x8i.96xlarge",
    "m5dn.large",
    "m6a.large",
    "c6i.large",
    "c8ib.metal-96xl",
    "m5a.4xlarge",
    "i7ie.18xlarge",
    "g6f.2xlarge",
    "i7ie.xlarge",
    "m7i.24xlarge",
    "d2.8xlarge",
    "r6id.12xlarge",
    "m5ad.4xlarge",
    "r7i.metal-48xl",
    "m6i.24xlarge",
    "m6idn.4xlarge",
    "c8a.medium",
    "c8id.16xlarge",
    "r8i.24xlarge",
    "c6i.2xlarge",
    "c4.8xlarge",
    "r8i.32xlarge",
    "m8id.2xlarge",
    "c7i-flex.2xlarge",
    "m5.12xlarge",
    "r8idb.2xlarge",
    "m5ad.large",
    "m6idn.12xlarge",
    "r5ad.24xlarge",
    "c5n.large",
    "c7i-flex.8xlarge",
    "c7a.large",
    "c5ad.4xlarge",
    "trn1.2xlarge",
    "x1.16xlarge",
    "m6id.32xlarge",
    "r7iz.xlarge",
    "x2iedn.xlarge",
    "m5.24xlarge",
    "r6idn.8xlarge",
    "t3a.2xlarge",
    "c7i-flex.16xlarge",
    "c6id.24xlarge",
    "r8a.8xlarge",
    "m5zn.large",
    "m6id.12xlarge",
    "c6a.32xlarge",
    "inf2.8xlarge",
    "r8ib.96xlarge",
    "m5zn.6xlarge",
    "x1e.32xlarge",
    "i7i.2xlarge",
    "r7iz.32xlarge",
    "r7a.4xlarge",
    "c7i.8xlarge",
    "c8id.4xlarge",
    "c5ad.12xlarge",
    "c5.4xlarge",
    "inf1.xlarge",
    "m7i.2xlarge",
    "r8a.medium",
    "m8in.xlarge",
    "g7e.8xlarge",
    "m7a.xlarge",
    "m7i.8xlarge",
    "m8idb.32xlarge",
    "r6idn.xlarge",
    "m8i.16xlarge",
    "c8in.large",
    "c8ib.48xlarge",
    "m8id.48xlarge",
    "x8i.16xlarge",
    "g7e.2xlarge",
    "r5b.12xlarge",
    "r8i.16xlarge",
    "i7i.12xlarge",
    "r3.8xlarge",
    "m8id.large",
    "c5d.12xlarge",
    "m8ine.12xlarge",
    "m8idb.4xlarge",
    "c6i.8xlarge",
    "m7i-flex.2xlarge",
    "r8idb.48xlarge",
    "r4.16xlarge",
    "r8ib.16xlarge",
    "r8idn.8xlarge",
    "r8i.large",
    "d3en.8xlarge",
    "m8idn.xlarge",
    "i7i.xlarge",
    "c6id.large",
    "x2idn.24xlarge",
    "c7a.2xlarge",
    "r6i.4xlarge",
    "d2.2xlarge",
    "c7a.4xlarge",
    "g6.8xlarge",
    "r8idb.8xlarge",
    "m6in.16xlarge",
    "r5a.12xlarge",
    "r8idb.24xlarge",
    "m8a.xlarge",
    "t3.2xlarge",
    "r8i.12xlarge",
    "a1.medium",
    "r8id.32xlarge",
    "r6in.large",
    "r8id.xlarge",
    "g4ad.8xlarge",
    "c8a.16xlarge",
    "r6idn.24xlarge",
    "m8i-flex.2xlarge",
    "c5a.4xlarge",
    "r7a.medium",
    "r5ad.12xlarge",
    "c8i.large",
    "m6i.8xlarge",
    "g4ad.4xlarge",
    "m5d.large",
    "g7e.48xlarge",
    "r7i.16xlarge",
    "r7a.large",
    "r8idb.32xlarge",
    "m7a.16xlarge",
    "m6in.32xlarge",
    "m5dn.xlarge",
    "m6a.metal",
    "c8in.8xlarge",
    "g7e.4xlarge",
    "r5b.metal",
    "c5ad.16xlarge",
    "r5a.large",
    "r8idn.xlarge",
    "r6id.4xlarge",
    "m5dn.8xlarge",
    "m5.xlarge",
    "c6in.12xlarge",
    "x2iezn.8xlarge",
    "x8i.8xlarge",
    "mac-m4pro.metal",
    "t3.xlarge",
    "r5ad.8xlarge",
    "r8id.4xlarge",
    "m6in.24xlarge",
    "m5d.metal",
    "m7a.32xlarge",
    "i7ie.3xlarge",
    "i4i.metal",
    "c8in.xlarge",
    "m8idn.96xlarge",
    "m5d.16xlarge",
    "i7i.large",
    "m6in.12xlarge",
    "g4dn.metal",
    "c8i-flex.2xlarge",
    "m5.metal",
    "c6i.24xlarge",
    "r6i.24xlarge",
    "m5ad.8xlarge",
    "m8ib.xlarge",
    "i7ie.12xlarge",
    "c7a.8xlarge",
    "r6a.32xlarge",
    "m8idn.16xlarge",
    "g7e.12xlarge",
    "g4dn.12xlarge",
    "m8ib.large",
    "c4.large",
    "x8i.4xlarge",
    "c8ib.large",
    "u7i-12tb.224xlarge",
    "t3.medium",
    "c8ine.12xlarge",
    "z1d.xlarge",
    "m8azn.large",
    "x2iedn.metal",
    "c6id.16xlarge",
    "t2.large",
    "x8i.2xlarge",
    "r6a.12xlarge",
    "d3.8xlarge",
    "c5.xlarge",
    "r6a.8xlarge",
    "c5a.12xlarge",
    "u-3tb1.56xlarge",
    "m5n.8xlarge",
    "g4ad.2xlarge",
    "t3.large",
    "c8i.24xlarge",
    "c8in.32xlarge",
    "inf2.24xlarge",
    "h1.8xlarge",
    "a1.large",
    "m4.xlarge",
    "i7ie.metal-48xl",
    "r5n.4xlarge",
    "r8idb.large",
    "c8i-flex.16xlarge",
    "m2.2xlarge",
    "g6e.16xlarge",
    "c8i.96xlarge",
    "mac1.metal",
    "t3a.small",
    "x8i.32xlarge",
    "p4de.24xlarge",
    "c5n.4xlarge",
    "x8i.64xlarge",
    "m8a.16xlarge",
    "c1.xlarge",
    "m8ib.4xlarge",
    "c6in.16xlarge",
    "c6i.16xlarge",
    "a1.xlarge",
    "m8idn.12xlarge",
    "r8i.2xlarge",
    "m8in.32xlarge",
    "g5.24xlarge",
    "c5n.9xlarge",
    "r8id.metal-96xl",
    "r5a.16xlarge",
    "r8i.96xlarge",
    "c5a.xlarge",
    "r7iz.metal-16xl",
    "m8idb.48xlarge",
    "r8idb.96xlarge",
    "c7i.metal-24xl",
    "g6.48xlarge",
    "c5d.2xlarge",
    "m5ad.2xlarge",
    "r5b.large",
    "r5.large",
    "i4i.4xlarge",
    "c5ad.xlarge",
    "c8i.4xlarge",
    "mac2.metal",
    "r7i.2xlarge",
    "r3.2xlarge",
    "t3a.medium",
    "r5d.4xlarge",
    "vt1.6xlarge",
    "c5.12xlarge",
    "m8a.large",
    "c7i-flex.4xlarge",
    "m8ine.2xlarge",
    "d3en.4xlarge",
    "c5d.24xlarge",
    "c7i.large",
    "r3.4xlarge",
    "c1.medium",
    "m6i.16xlarge",
    "c6in.8xlarge",
    "c7i.xlarge",
    "r5.metal",
    "r7i.12xlarge",
    "r8i-flex.2xlarge",
    "m8i-flex.16xlarge",
    "c6a.12xlarge",
    "r5a.4xlarge",
    "c5a.2xlarge",
    "inf1.6xlarge",
    "r5ad.large",
    "m8idn.32xlarge",
    "r8ib.48xlarge",
    "t2.micro",
    "p6-b200.48xlarge",
    "r6id.32xlarge",
    "m6i.metal",
    "m8in.48xlarge",
    "h1.2xlarge",
    "u7in-24tb.224xlarge",
    "i7ie.48xlarge",
    "r8idn.12xlarge",
    "c6a.8xlarge",
    "m5n.12xlarge",
    "r8a.48xlarge",
    "c8in.metal-96xl",
    "c7i-flex.xlarge",
    "g6e.12xlarge",
    "inf1.2xlarge",
    "r8ib.12xlarge",
    "m6idn.xlarge",
    "vt1.3xlarge",
    "m7i.48xlarge",
    "r8idn.24xlarge",
    "c5a.24xlarge",
    "m8id.metal-96xl",
    "r5dn.xlarge",
    "g5.12xlarge",
    "i4i.2xlarge",
    "r7i.8xlarge",
    "x8i.large",
    "m8ib.24xlarge",
    "r5b.24xlarge",
    "r8i.xlarge",
    "m5zn.3xlarge",
    "m8i.xlarge",
    "d3.xlarge",
    "m4.large",
    "r8id.2xlarge",
    "d3.2xlarge",
    "c7a.12xlarge",
    "r5dn.large",
    "r5.4xlarge",
    "r8a.metal-24xl",
    "r8in.large",
    "u-6tb1.56xlarge",
    "c7i.16xlarge",
    "x8i.24xlarge",
    "c8ine.8xlarge",
    "c6in.2xlarge",
    "r5n.16xlarge",
    "m8i.32xlarge",
    "u7in-16tb.224xlarge",
    "c6a.metal",
    "c8i-flex.4xlarge",
    "h1.4xlarge",
    "c8a.large",
    "m6i.32xlarge",
    "r8in.4xlarge",
    "r5b.2xlarge",
    "r8in.2xlarge",
    "m6idn.32xlarge",
    "m5n.large",
    "r8idn.large",
    "r8in.12xlarge",
    "r5b.xlarge",
    "r6a.48xlarge",
    "r5n.24xlarge",
    "m1.xlarge",
    "d3en.6xlarge",
    "c7i-flex.12xlarge",
    "m8in.4xlarge",
    "c3.xlarge",
    "c8id.48xlarge",
    "r5n.2xlarge",
    "r5d.2xlarge",
    "r5d.large",
    "r5dn.metal",
    "m8a.metal-48xl",
    "r5d.16xlarge",
    "p5.48xlarge",
    "r7i.metal-24xl",
    "m6in.metal",
    "c8a.xlarge",
    "m5n.4xlarge",
    "c7i-flex.large",
    "m8idn.48xlarge",
    "r5b.4xlarge",
    "m8i.8xlarge",
    "r5d.xlarge",
    "m3.xlarge",
    "c5d.4xlarge",
    "c5.24xlarge",
    "m6a.4xlarge",
    "c8a.metal-24xl",
    "r6id.24xlarge",
    "i7i.metal-24xl",
    "m8in.24xlarge",
    "x8i.metal-96xl",
    "r8a.metal-48xl",
    "m5zn.12xlarge",
    "c8i.16xlarge",
    "m6in.4xlarge",
    "p4d.24xlarge",
    "r8in.32xlarge",
    "r5.16xlarge",
    "m7a.medium",
    "r7iz.2xlarge",
    "r8idn.2xlarge",
    "c7i.24xlarge",
    "m8azn.6xlarge",
    "m5.4xlarge",
    "r6in.32xlarge",
    "i2.xlarge",
    "i7ie.metal-24xl",
    "m8id.xlarge",
    "m5n.metal",
    "m4.16xlarge",
    "m8idb.xlarge",
    "r8ib.24xlarge",
    "c7a.16xlarge",
    "r6a.4xlarge",
    "c8in.12xlarge",
    "m6id.metal",
    "c4.2xlarge",
    "i7i.16xlarge",
    "m6a.16xlarge",
    "c8in.96xlarge",
    "m8idn.4xlarge",
    "i4i.large",
    "r6in.4xlarge",
    "c8in.metal-48xl",
    "r6i.16xlarge",
    "m5zn.metal",
    "m5dn.metal",
    "t3.nano",
    "t3.micro",
    "c6in.large",
    "r8i-flex.4xlarge",
    "i7i.4xlarge",
    "r6idn.large",
    "r8in.8xlarge",
    "x2iedn.4xlarge",
    "r7i.xlarge",
    "m6id.16xlarge",
    "r7a.24xlarge",
    "m6i.4xlarge",
    "m5a.8xlarge",
    "c5.metal",
    "h1.16xlarge",
    "r8idb.16xlarge",
    "c8i.48xlarge",
    "r5d.24xlarge",
    "m8i.2xlarge",
    "c7i.metal-48xl",
    "c5n.18xlarge",
    "a1.metal",
    "c4.xlarge",
    "m8ib.12xlarge",
    "c7a.24xlarge",
    "c8ib.12xlarge",
    "r3.xlarge",
    "r8a.xlarge",
    "m8ib.96xlarge",
    "c8a.48xlarge",
    "r8idn.32xlarge",
    "c5ad.2xlarge",
    "p5.4xlarge",
    "r6idn.4xlarge",
    "r4.2xlarge",
    "m7i-flex.16xlarge",
    "c8i.12xlarge",
    "m7a.24xlarge",
    "m6idn.2xlarge",
    "c5.9xlarge",
    "r8in.48xlarge",
    "u-6tb1.112xlarge",
    "x2iezn.12xlarge",
    "c6id.32xlarge",
    "r4.xlarge",
    "i3.xlarge",
    "c8ib.2xlarge",
    "x2idn.metal",
    "r5ad.2xlarge",
    "mac-m4max.metal",
    "r8idb.4xlarge",
    "c5d.18xlarge",
    "m5d.24xlarge",
    "m7a.48xlarge",
    "c6a.xlarge",
    "r5ad.16xlarge",
    "i2.4xlarge",
    "c8in.4xlarge",
    "m5.16xlarge",
    "m4.2xlarge",
    "x2iedn.16xlarge",
    "m8idb.96xlarge",
    "m6idn.24xlarge",
    "m5ad.24xlarge",
    "m5ad.xlarge",
    "c7a.32xlarge",
    "a1.2xlarge",
    "r5d.8xlarge",
    "m8in.12xlarge",
    "c5a.16xlarge",
    "r5dn.12xlarge",
    "z1d.metal",
    "m3.2xlarge",
    "m8i.48xlarge",
    "m8azn.metal-12xl",
    "r6i.12xlarge",
    "m8id.8xlarge",
    "c5n.metal",
    "i7i.metal-48xl",
    "z1d.12xlarge",
    "r5b.16xlarge",
    "r6in.8xlarge",
    "t2.medium",
    "m7a.4xlarge",
    "r8idn.96xlarge",
    "c6id.metal",
    "r8i.4xlarge",
    "m7i-flex.4xlarge",
    "m8in.2xlarge",
    "c6in.32xlarge",
    "r7i.large",
    "r6a.24xlarge",
    "i2.8xlarge",
    "c8a.4xlarge",
    "r6id.large",
    "r8idb.12xlarge",
    "c8id.xlarge",
    "inf2.xlarge",
    "m8azn.xlarge",
    "c5.large",
    "u7i-8tb.112xlarge",
    "x1e.16xlarge",
    "g6.2xlarge",
    "m6in.xlarge",
    "c3.4xlarge",
    "r8a.24xlarge",
    "t3a.large",
    "r5.2xlarge",
    "c8in.16xlarge",
    "r5.8xlarge",
    "c6a.4xlarge",
    "r7a.metal-48xl",
    "m6idn.metal",
    "c8a.8xlarge",
    "mac2-m1ultra.metal",
    "m8idb.8xlarge",
    "m8i.4xlarge",
    "g6.xlarge",
    "m6in.large",
    "r8a.12xlarge",
    "m8ib.48xlarge",
    "r5.xlarge",
    "m7a.8xlarge",
    "r5dn.16xlarge",
    "g5.16xlarge",
    "g4dn.xlarge",
    "i3.large",
    "c7a.48xlarge",
    "x2idn.16xlarge",
    "c8a.24xlarge",
    "mac-m4.metal",
    "m7a.12xlarge",
    "m8ine.xlarge",
    "i3.8xlarge",
    "g6.16xlarge",
    "c8i.xlarge",
    "r8i.metal-96xl",
    "i3.16xlarge",
    "t2.xlarge",
    "c6id.12xlarge",
    "r8ib.32xlarge",
    "vt1.24xlarge",
    "c6in.4xlarge",
    "r8idn.16xlarge",
    "c8i-flex.xlarge",
    "g6f.large",
    "r7a.8xlarge",
    "r8a.16xlarge",
    "r6i.metal",
    "r6id.metal",
    "r6id.8xlarge",
    "m8id.12xlarge",
    "i7i.8xlarge",
    "c5d.xlarge",
    "z1d.6xlarge",
    "c8id.large",
    "m5.2xlarge",
    "x2iezn.2xlarge",
    "x2iezn.metal",
    "z1d.large",
    "g5.xlarge",
    "c8ine.large",
    "m5dn.24xlarge",
    "x8i.metal-48xl",
    "g6.12xlarge",
    "m5dn.4xlarge",
    "r6idn.32xlarge",
    "m8idn.8xlarge",
    "m8id.metal-48xl",
    "x2idn.32xlarge",
    "m6id.4xlarge",
    "c3.2xlarge",
    "f2.48xlarge",
    "r5n.xlarge",
    "m5n.24xlarge",
    "m5n.xlarge",
    "m8a.metal-24xl",
    "c5d.metal",
    "x8i.xlarge",
    "m8a.2xlarge",
    "m7i.large",
    "m5d.12xlarge",
    "c8id.12xlarge",
    "r6a.16xlarge",
    "m4.10xlarge",
    "c5.2xlarge",
    "r5ad.xlarge",
    "r6idn.metal",
    "c7i.4xlarge",
    "m5.large",
    "r8i.metal-48xl",
    "r6in.16xlarge",
    "m5zn.xlarge",
    "r8in.96xlarge",
    "m8azn.medium",
    "a1.4xlarge",
    "m5dn.16xlarge",
    "r5d.metal",
    "mac2-m2pro.metal",
    "m5d.2xlarge",
    "m8i.metal-96xl",
    "p5en.48xlarge",
    "m5a.large",
    "g4ad.16xlarge",
    "r5dn.2xlarge",
    "m6idn.16xlarge",
    "r8id.12xlarge",
    "g6e.4xlarge",
    "g6e.2xlarge",
    "r5n.8xlarge",
    "c6id.xlarge",
    "m8i-flex.4xlarge",
    "d2.4xlarge",
    "m7i.xlarge",
    "i4i.12xlarge",
    "c7i.12xlarge",
    "c8ine.2xlarge",
    "r7i.24xlarge",
    "m8i.large",
    "c8id.metal-48xl",
    "g6f.4xlarge",
    "r8id.metal-48xl",
    "m5n.2xlarge",
    "i3en.large",
    "dl1.24xlarge",
    "r8in.24xlarge",
    "m8in.large",
    "m8a.4xlarge",
    "t3.small",
    "g4dn.16xlarge",
    "i3en.xlarge",
    "r7iz.metal-32xl",
    "m6idn.8xlarge",
    "r5b.8xlarge",
    "c5ad.8xlarge",
    "m8azn.24xlarge",
    "x1e.xlarge",
    "r8i-flex.12xlarge",
    "d3.4xlarge",
    "m6i.xlarge",
    "r5a.8xlarge",
    "m7i-flex.8xlarge",
    "m8i.24xlarge",
    "g6.4xlarge",
    "c6i.metal",
    "gr6.8xlarge",
    "x2iezn.6xlarge",
    "r8idn.48xlarge",
    "m8idn.24xlarge",
    "r5.12xlarge",
    "c6a.2xlarge",
    "gr6.4xlarge",
    "r4.large",
    "r5a.24xlarge",
    "x8i.12xlarge",
    "i4i.32xlarge",
    "g6e.xlarge",
    "m8ine.4xlarge",
    "i4i.xlarge",
    "r8ib.large",
    "c8in.2xlarge",
    "m8i-flex.12xlarge",
    "m5ad.16xlarge",
    "m8ine.large",
    "t2.small",
    "c5a.8xlarge",
    "r4.8xlarge",
    "i3en.2xlarge",
    "m7a.2xlarge",
    "m8idb.large",
    "m6a.24xlarge",
    "r5d.12xlarge",
    "c8i.metal-96xl",
    "r6a.large",
    "c5ad.large",
    "x2iedn.24xlarge",
    "r5ad.4xlarge",
    "inf1.24xlarge",
    "c8a.12xlarge",
    "f2.12xlarge",
    "r7i.48xlarge",
    "m6a.xlarge",
    "m8id.32xlarge",
    "c6i.xlarge",
    "c8i.32xlarge",
    "r6idn.12xlarge",
    "m6id.large",
    "i3.2xlarge",
    "m7a.metal-48xl",
    "m6a.32xlarge",
    "m8ib.32xlarge",
    "r8in.16xlarge",
    "r4.4xlarge",
    "r8idn.4xlarge",
    "r8idb.xlarge",
    "gr6f.4xlarge",
    "i7i.24xlarge",
    "c6id.2xlarge",
    "m7i.12xlarge",
    "m8i-flex.xlarge",
    "c6i.12xlarge",
    "x1e.4xlarge",
    "i7ie.6xlarge",
    "u7in-32tb.224xlarge",
    "m6a.8xlarge",
    "m8in.96xlarge",
    "r7a.16xlarge",
    "r8i-flex.xlarge",
    "m3.medium",
    "r6in.xlarge",
    "r6i.8xlarge",
    "r8ib.4xlarge",
    "c8i-flex.12xlarge",
    "m6in.2xlarge",
    "m8idn.large",
    "x1.32xlarge",
    "i3.4xlarge",
    "t2.nano",
    "r6i.32xlarge",
    "c6id.4xlarge",
    "m8i-flex.large",
    "z1d.3xlarge",
    "c5n.xlarge",
    "r8i-flex.large",
    "i7ie.large",
    "g5.8xlarge",
    "m6id.24xlarge",
    "m8ib.8xlarge",
    "x2iedn.32xlarge",
    "m7i-flex.xlarge",
    "r7a.12xlarge",
    "m7i.4xlarge",
    "m2.xlarge",
    "c8ib.metal-48xl",
    "m3.large",
    "g6f.xlarge",
    "m5a.24xlarge",
    "m5d.4xlarge",
    "m6id.8xlarge",
    "i7i.48xlarge",
    "r7i.4xlarge",
    "m8i.96xlarge",
    "g5.48xlarge",
    "m8ine.8xlarge",
    "m6in.8xlarge",
    "t3a.nano",
    "x2iedn.8xlarge",
    "c8i-flex.large",
    "m7i-flex.large",
    "m5a.xlarge",
    "r5dn.4xlarge",
    "r6i.2xlarge",
    "c5a.large",
    "r8i.8xlarge",
    "d3en.xlarge",
    "t3a.micro",
    "c8ib.24xlarge",
    "x8i.48xlarge",
    "mac-m3ultra.metal",
    "m5a.12xlarge",
    "r7iz.large",
    "g4ad.xlarge",
    "r8a.4xlarge",
    "r5n.large",
    "c8i.2xlarge",
    "c8id.metal-96xl",
    "m8idn.2xlarge",
    "m8idb.12xlarge",
    "c8id.32xlarge",
    "r6in.2xlarge",
    "c8ib.96xlarge",
    "m6a.12xlarge",
    "m6i.12xlarge",
    "i3en.metal",
    "r7a.48xlarge",
    "i4i.8xlarge",
    "c7i.48xlarge",
    "m8i-flex.8xlarge",
    "t3a.xlarge",
    "c5d.9xlarge",
    "r8id.large",
    "m8id.4xlarge",
    "c8ib.xlarge",
    "c8id.8xlarge",
    "c8ib.16xlarge",
    "p3dn.24xlarge",
    "r8id.24xlarge",
    "p6-b300.48xlarge",
    "r6i.large",
    "m7a.large",
    "c8a.metal-48xl",
    "r7iz.4xlarge",
    "r5dn.24xlarge",
    "g7e.24xlarge",
    "c8i.metal-48xl",
    "m8a.24xlarge",
    "c5.18xlarge",
    "g4dn.4xlarge",
    "m8i.metal-48xl",
    "i7ie.2xlarge",
    "m6i.2xlarge",
    "i3en.6xlarge",
    "r5n.metal",
    "r8ib.8xlarge",
    "m7i.metal-48xl",
    "c6in.metal",
    "c6a.large",
    "r8ib.2xlarge",
    "d2.xlarge",
    "m8in.8xlarge",
    "g4dn.8xlarge",
    "m8idb.24xlarge",
    "d3en.12xlarge",
    "m6a.48xlarge",
    "m1.small",
    "m1.medium",
    "r8i-flex.16xlarge",
    "m8azn.metal-24xl",
    "g6e.24xlarge",
    "g4dn.2xlarge",
    "m1.large"
].sort().map(t => ({ value: t, label: t }));

/**
 * Custom instance families understood by our infrastructure. The family name
 * is submitted as the instance type value; the infrastructure resolves it to
 * one of the listed instances depending on availability.
 */
export interface AwsInstanceFamily {
  name: string;
  graviton: boolean;
  instances: string[];
}

export const AWS_INSTANCE_FAMILIES: AwsInstanceFamily[] = [
  {
    name: 'test',
    graviton: false,
    instances: ['t3.medium'],
  },
  {
    name: 'tiny',
    graviton: false,
    instances: [
      'm5n.xlarge', 'm5d.xlarge', 'm5dn.xlarge', 'm5.xlarge', 'c5.xlarge',
      'c5d.xlarge', 'c5n.xlarge', 'c4.xlarge', 'm4.xlarge',
    ],
  },
  {
    name: 'small',
    graviton: false,
    instances: [
      'm5n.2xlarge', 'm5d.2xlarge', 'm5dn.2xlarge', 'm5.2xlarge', 'c5.2xlarge',
      'c5d.2xlarge', 'c5n.2xlarge', 'c4.2xlarge', 'm4.2xlarge',
    ],
  },
  {
    name: 'medium',
    graviton: false,
    instances: [
      'm5n.4xlarge', 'm5d.4xlarge', 'm5dn.4xlarge', 'm5.4xlarge', 'c5.4xlarge',
      'c5d.4xlarge', 'c5n.4xlarge', 'c4.4xlarge', 'm4.4xlarge',
    ],
  },
  {
    name: 'large',
    graviton: false,
    instances: [
      'm5n.8xlarge', 'm5d.8xlarge', 'm5dn.8xlarge', 'm5.8xlarge', 'c5.9xlarge',
      'c5d.9xlarge', 'c5n.9xlarge', 'c4.8xlarge', 'm4.10xlarge',
    ],
  },
  {
    name: 'large_plus',
    graviton: false,
    instances: [
      'm5n.12xlarge', 'm5d.12xlarge', 'm5dn.12xlarge', 'm5.12xlarge',
      'c5.12xlarge', 'c5d.12xlarge', 'm4.10xlarge',
    ],
  },
  {
    name: 'huge',
    graviton: false,
    instances: [
      'm5n.16xlarge', 'm5d.16xlarge', 'm5dn.16xlarge', 'm5.16xlarge',
      'c5.18xlarge', 'c5d.18xlarge', 'c5n.18xlarge',
    ],
  },
  {
    name: 'huge_plus',
    graviton: false,
    instances: [
      'm5n.24xlarge', 'm5d.24xlarge', 'm5dn.24xlarge', 'm5.24xlarge',
      'c5.24xlarge', 'c5d.24xlarge',
    ],
  },
  {
    name: 'graviton_nano',
    graviton: true,
    instances: ['t4g.small', 'm6g.medium'],
  },
  {
    name: 'graviton_small',
    graviton: true,
    instances: ['t4g.large', 'm6g.large', 'r6g.large'],
  },
  {
    name: 'graviton_small_plus',
    graviton: true,
    instances: [
      'c8g.2xlarge', 'c7g.2xlarge', 'c6g.2xlarge', 'm8g.2xlarge', 'm7g.2xlarge',
      'm6g.2xlarge', 'r8g.2xlarge', 'r7g.2xlarge', 'r6g.2xlarge',
    ],
  },
  {
    name: 'graviton_medium',
    graviton: true,
    instances: [
      'c8g.4xlarge', 'c7g.4xlarge', 'c6g.4xlarge', 'm8g.4xlarge', 'm7g.4xlarge',
      'm6g.4xlarge', 'r8g.4xlarge', 'r7g.4xlarge', 'r6g.4xlarge',
    ],
  },
  {
    name: 'graviton_large',
    graviton: true,
    instances: [
      'c8g.8xlarge', 'c7g.8xlarge', 'c6g.8xlarge', 'm8g.8xlarge', 'm7g.8xlarge',
      'm6g.8xlarge', 'r8g.8xlarge', 'r7g.8xlarge', 'r6g.8xlarge',
    ],
  },
];

const familyOption = (f: AwsInstanceFamily) => ({ value: f.name, label: `${f.name} (${f.instances[0]})` });

export const AWS_GRAVITON_FAMILY_OPTIONS = AWS_INSTANCE_FAMILIES.filter(f => f.graviton).map(familyOption);
export const AWS_NONGRAVITON_FAMILY_OPTIONS = AWS_INSTANCE_FAMILIES.filter(f => !f.graviton).map(familyOption);